export const Services = {
   "TABLEROS": {
      "path": "https://roldanapitablerosaduana.azurewebsites.net",
      "descrp": "API tableros"
   },
   "DOWNLOAD_FILES": {
      "path": "https://servicereportapi.azurewebsites.net",
      "method": "GET",
      "descrp": "method to obtain contacts and users related to the customer, for the modality of view and edition ******ROLDAN********"
   }
}